import { createRouter, createWebHistory } from 'vue-router'
import AILogoGenerator from '../components/AILogoGenerator.vue'

// 定义路由
const routes = [
  {
    path: '/',
    name: 'Home',
    component: AILogoGenerator,
    meta: {
      keepAlive: true // 添加缓存标记
    }
  },
  {
    path: '/test',
    name: 'Test',
    component: () => import('../components/TestPage.vue'),
    meta: {
      title: '页面测试'
    }
  },
  {
    path: '/ai-generator',
    name: 'AIGenerator',
    component: () => import('../components/AILogoGenerator.vue'),
    meta: {
      title: 'AI LOGO生成器'
    }
  },
  {
    path: '/detail/:id',
    name: 'Detail',
    // 使用动态导入实现路由懒加载
    component: () => import('../components/LogoDetail.vue'),
    props: true
  },
  {
    path: '/favorites',
    name: 'Favorites',
    component: () => import('../components/LogoFavorites.vue')
  },
  {
    path: '/history',
    name: 'History',
    component: () => import('../views/HistoryPage.vue'),
    meta: {
      title: 'AI Logo历史记录'
    }
  },
  {
    path: '/history-test',
    name: 'HistoryTest',
    component: () => import('../components/HistoryTest.vue'),
    meta: {
      title: '历史记录功能测试'
    }
  },
  {
    path: '/canvas-editor',
    name: 'SvgCanvasEditor',
    component: () => import('../components/SvgCanvasEditor.vue'),
    meta: {
      title: 'SVG编辑器'
    }
  },
  {
    path: '/mobile-editor',
    name: 'SvgCanvasEditorMobile',
    component: () => import('../components/SvgCanvasEditorMobile.vue'),
    meta: {
      title: '移动端SVG编辑器'
    }
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../components/About.vue')
  },
  {
    path: '/logo-list',
    name: 'LogoList',
    component: () => import('@/components/LogoList.vue'),
    meta: {
      keepAlive: true // 添加缓存标记
    }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('../components/NotFound.vue')
  }
]

// 修改路由实例创建
const router = createRouter({
  // 直接使用固定的base路径
  history: createWebHistory('/aitool/'),
  routes
})

// 全局前置守卫
router.beforeEach((to, from, next) => {
  console.log('路由导航:', {
    from: from.fullPath,
    to: to.fullPath,
    name: to.name
  })
  
  // 设置页面标题
  document.title = to.meta.title || 'LOGO设计生成器'
  
  // 可以在这里添加权限验证等逻辑
  
  next()
})

export default router 